import * as IO from "../../helpers/io.js";
//
// Model.
//
export const RVersionLinkName = "VersionLink";
const RVersionLinkRaw = IO.dualObject({
    entity: IO.string,
    recordId: IO.string,
    versionHash: IO.string,
}, {
    originalEntity: IO.string,
}, RVersionLinkName);
export const RVersionLink = IO.clean(RVersionLinkRaw);
//
// I/O.
//
function buildVersionLink(entity, recordId, versionHash) {
    return { entity, recordId, versionHash };
}
export const VersionLink = {
    new: buildVersionLink,
};
